

















import { Component, Prop, PropSync, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: {
    Treeselect
  }
})
export default class ProviderCurrenciesList extends Mixins(
  HasValidation,
  CurrenciesStore
) {
  @Prop({ required: true })
  public isProcessing!: boolean;

  @PropSync("gatewayProviderCurrencies", { required: true })
  public gatewayProviderCurrenciesSynced!: number[];
  public value: number[] = [];

  public get options() {
    return [
      {
        id: 0,
        label: this.$t("_.all"),
        children: this.currencies.map(currency => {
          return {
            id: currency.id,
            label: currency.code
          };
        })
      }
    ];
  }
}
